
































































































































import { Component, Inject, Mixins, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import HasValidation from "@/mixins/HasValidation";
import Context from "@/mixins/context";
import {
  IProductConfigProviderData,
  IProductConfigProviderMethods
} from "@/models/providers/products";
import { BrandConfigKeys } from "@/data/constants";
import { PromotionDisplayTypes } from "@/data/enums/promotions";

@Component({
  components: {
    "editable-price": () =>
      import(
        "@/components/app/global/baskets/basket/productView/editablePrice.vue"
      )
  },
  computed: {
    ...mapGetters({
      getBillingCycleName: "constants/getBillingCycleName",
      getCurrency: "constants/getCurrency"
    })
  }
})
export default class ProductTerms extends Mixins(HasValidation, Context) {
  // Inject
  @Inject({ from: "productConfigProviderData" })
  public readonly $productConfigData!: () => IProductConfigProviderData;
  @Inject({ from: "productConfigProviderMethods" })
  public readonly $methods!: IProductConfigProviderMethods;
  // Props
  @Prop({ default: false })
  public disabled!: boolean;
  // Computed
  public get $product() {
    return this.$productConfigData();
  }
  public termKey(term) {
    return `${this.$product.productId}_${term.billing_cycle_months}`;
  }
  public handleClick($e, selected) {
    if (selected && this.isAdmin) {
      $e.preventDefault();
      $e.stopPropagation();
    }
  }

  public getPromoTags(item) {
    const displayType =
      this.$store.getters["brand/config"][BrandConfigKeys.SHOW_PROMOTION_AS] ||
      PromotionDisplayTypes.PERCENTAGE;
    const tooltip = item.hasMixedPromotions
      ? this.$t("_sentence.promotion.discount_will_be_auto_applied")
      : item.saving_summary;
    switch (displayType) {
      case PromotionDisplayTypes.NAME:
        return this.$_.map(item.promotionsByName, promo => ({
          label: promo,
          tooltip
        }));
      case PromotionDisplayTypes.PERCENTAGE:
        return [
          {
            label: item.hasMixedPromotions
              ? this.$t("_.on_promotion")
              : this.$t("_.save_percentage", {
                  percentage: item.saving_formatted
                }),
            tooltip
          }
        ];
      case PromotionDisplayTypes.LABEL:
      default:
        return [
          {
            label: this.$t("_.on_promotion"),
            tooltip
          }
        ];
    }
  }
}
